import actions from '@/core/store/item-ata/alterar-classificacao/historico/actions'
import state from '@/core/store/item-ata/alterar-classificacao/historico/state'
import mutations from '@/core/store/item-ata/alterar-classificacao/historico/mutations'

export default { actions, state, mutations }
